// Compact Indian-rupee formatting: ₹4.82L, ₹1.20Cr, ₹84,500.
export function formatINR(n) {
  if (n == null || Number.isNaN(Number(n))) return "₹0";
  const v = Number(n);
  if (Math.abs(v) >= 10000000) return `₹${(v / 10000000).toFixed(2)}Cr`;
  if (Math.abs(v) >= 100000) return `₹${(v / 100000).toFixed(2)}L`;
  return `₹${v.toLocaleString("en-IN")}`;
}

export function initials(name) {
  if (!name) return "?";
  return name.split(" ").filter(Boolean).slice(0, 2).map((p) => p[0]?.toUpperCase()).join("");
}

export function titleCase(s = "") {
  return s.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function timeAgo(date) {
  if (!date) return "";
  const mins = Math.round((Date.now() - new Date(date).getTime()) / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.round(hrs / 24);
  if (days < 30) return `${days}d ago`;
  return new Date(date).toLocaleDateString("en-IN", { day: "numeric", month: "short" });
}

export const ROLE_LABELS = {
  PLATFORM_ADMIN: "Platform Admin",
  SHOP_ADMIN: "Shop Admin",
  ACCOUNT_MANAGER: "Account Manager",
  SALES_EXECUTIVE: "Sales Executive",
  EXTERNAL_ARCHITECT: "Architect",
  EXTERNAL_DESIGNER: "Designer",
};
